import { TabsContent } from "twyne-new.ui"

import { define } from "../../utils"

function TabContentPreview({ children, value, key }) {
  return <TabsContent value={value} key={key}>
    {children}
  </TabsContent>
}

export default define('variants-tab-content', TabContentPreview)
  .build()
